document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     3D PUFF COVERAGE + LOCATION SELECTION
     ========================================================= */

  var coverageButtons = document.querySelectorAll(
    '[data-puff-coverage]'
  );

  var locationWrap = document.getElementById(
    'sphPuffLocationWrap'
  );

  var locationInputs = document.querySelectorAll(
    '[data-puff-location]'
  );

  if (!coverageButtons.length) {
    return;
  }

  /*
   * Global values
   * These are used when the product is added to cart.
   */
  window.sphPuffCoverage = '';
  window.sphPuffLocations = [];


  /* =========================================================
     LOCATION UI
     ========================================================= */

  function updateLocationUI() {

    var coverage = window.sphPuffCoverage;

    if (!locationWrap) {
      return;
    }

    /*
     * Nothing selected
     */
    if (!coverage) {

      locationWrap.hidden = true;

      locationInputs.forEach(function (input) {
        input.checked = false;
      });

      window.sphPuffLocations = [];

      return;
    }


    /*
     * ALL LOCATIONS
     *
     * Automatically select every available location.
     */
    if (coverage === 'all') {

      locationWrap.hidden = true;

      locationInputs.forEach(function (input) {
        input.checked = true;
      });

      window.sphPuffLocations =
        Array.from(locationInputs).map(function (input) {
          return input.value;
        });

      console.log(
        '3D Puff Coverage:',
        'all'
      );

      console.log(
        '3D Puff Locations:',
        window.sphPuffLocations
      );

      return;
    }


    /*
     * ONE / TWO LOCATIONS
     *
     * Show location selector.
     */
    locationWrap.hidden = false;

    locationInputs.forEach(function (input) {
      input.checked = false;
    });

    window.sphPuffLocations = [];

  }


  /* =========================================================
     COVERAGE BUTTONS
     ========================================================= */

  coverageButtons.forEach(function (btn) {

    btn.setAttribute(
      'aria-pressed',
      'false'
    );


    btn.addEventListener('click', function () {

      var selectedCoverage =
        this.dataset.puffCoverage;


      /*
       * Save coverage globally
       */
      window.sphPuffCoverage =
        selectedCoverage;


      /*
       * Update button selected state
       */
      coverageButtons.forEach(function (item) {

        item.setAttribute(
          'aria-pressed',
          item.dataset.puffCoverage === selectedCoverage
            ? 'true'
            : 'false'
        );

      });


      /*
       * Update location selector
       */
      updateLocationUI();


      console.log(
        '3D Puff Coverage:',
        selectedCoverage
      );

    });

  });


  /* =========================================================
     LOCATION CHECKBOXES
     ========================================================= */

  locationInputs.forEach(function (input) {

    input.addEventListener('change', function () {

      var maxLocations = 1;


      /*
       * TWO LOCATIONS
       */
      if (window.sphPuffCoverage === 'two') {
        maxLocations = 2;
      }


      /*
       * Get currently selected locations
       */
      var selected = Array.from(locationInputs)
        .filter(function (item) {
          return item.checked;
        });


      /*
       * Prevent selecting more than allowed
       */
      if (selected.length > maxLocations) {

        this.checked = false;

        alert(
          'Please select only ' +
          maxLocations +
          ' location' +
          (maxLocations > 1 ? 's.' : '.')
        );

        return;
      }


      /*
       * Save selected locations globally
       */
      window.sphPuffLocations =
        selected.map(function (item) {
          return item.value;
        });


      console.log(
        '3D Puff Locations:',
        window.sphPuffLocations
      );

    });

  });

});


/* =========================================================
   3D PUFF → CART / ORDER PROPERTIES
   ========================================================= */

(function () {

  var originalFetch = window.fetch;


  window.fetch = function (url, options) {

    /*
     * Only intercept Shopify cart add request.
     */
    if (
      typeof url === 'string' &&
      url.indexOf('/cart/add.js') !== -1 &&
      options &&
      options.body
    ) {

      try {

        var data = JSON.parse(options.body);


        if (
          data &&
          Array.isArray(data.items)
        ) {

          var coverage =
            window.sphPuffCoverage || '';


          var locations =
            Array.isArray(window.sphPuffLocations)
              ? window.sphPuffLocations.slice()
              : [];


          /*
           * Only add these properties when
           * 3D Puff Coverage has been selected.
           */
          if (coverage) {


            var coverageLabels = {
              one: 'One Location',
              two: 'Two Locations',
              all: 'All Locations'
            };


            var coverageLabel =
              coverageLabels[coverage] ||
              coverage;


            /*
             * If All Locations is selected,
             * make sure every available location
             * is included.
             */
            if (
              coverage === 'all' &&
              !locations.length
            ) {

              locations = [
                'Front',
                'Back',
                'Left Side',
                'Right Side'
              ];

            }


            /*
             * Add properties to the main product item.
             *
             * Do not add them to addon items.
             */
            data.items.forEach(function (item) {

              var isAddon =
                item.properties &&
                item.properties['_item_type'] === 'addon';


              if (!isAddon) {


                /*
                 * Coverage
                 */
                item.properties =
                  item.properties || {};


                item.properties[
                  '3D Puff Coverage'
                ] = coverageLabel;


                /*
                 * Locations
                 */
                if (locations.length) {

                  item.properties[
                    '3D Puff Locations'
                  ] = locations.join(', ');

                }

              }

            });


            /*
             * Put modified data back into
             * the fetch request.
             */
            options.body =
              JSON.stringify(data);


            console.log(
              '3D Puff Cart Data:',
              data
            );

          }

        }

      } catch (error) {

        console.log(
          '3D Puff cart property error:',
          error
        );

      }

    }
    return originalFetch.apply(
      this,
      arguments
    );

  };

})();
